export enum DialogTypeEnum {
  Info = 0,
  Success = 1,
  Error = 2,
  Confirm = 3,
  HtmlContent = 4,
  Captcha = 5,
}
